const isHtmlStringEmpty = (htmlString: string) => {
  const document = new DOMParser().parseFromString(htmlString, 'text/html')
  const children = Array.from(document.body.children)
  const disclaimerOrLegalTextChildren = children.filter((child) => child.innerHTML !== '')
  return disclaimerOrLegalTextChildren.length <= 0
}

export default isHtmlStringEmpty
